const TURKISH_MAP: { [key: string]: string } = {
  ş: 's',
  Ş: 's',
  ı: 'i',
  İ: 'i',
  ğ: 'g',
  Ğ: 'g',
  ü: 'u',
  Ü: 'u',
  ö: 'o',
  Ö: 'o',
  ç: 'c',
  Ç: 'c'
};

export const normalizeText = (text: string): string =>
  text
    .split('')
    .map((char) => TURKISH_MAP[char] || char)
    .join('')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase();
